import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { OracleTableDataset } from 'app/model/dataset/oracle-table.dataset';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class OracleTableDatasetAdapter extends TabularTypeDatasetAdapter<OracleTableDataset, Model.DatasetResource> {
    protected model(): IModel {
        return OracleTableDataset.MODEL;
    }
    protected async _toResource(dataset: OracleTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, this.model().name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: OracleTableDataset): Promise<OracleTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, this.model());
    }
}
